export const PORTFOLIO_LIVE_VERSION_NAME = 'Portfolio live';
